import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }



export default /*@__PURE__*/_defineComponent({
  __name: 'LoadingComponent',
  props: {
    isLoading: { type: Boolean },
    message: {},
    overlay: { type: Boolean }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_ctx.isLoading)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass(['loading-container', {'overlay':_ctx.overlay}])
      }, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "spinner" }, null, -1)),
        (_ctx.message)
          ? (_openBlock(), _createElementBlock("p", _hoisted_1, _toDisplayString(_ctx.message), 1))
          : _createCommentVNode("", true)
      ], 2))
    : _createCommentVNode("", true)
}
}

})